import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInserBelow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 1.5C6.75329 1.5 2.5 5.75329 2.5 11C2.5 16.2467 6.75329 20.5 12 20.5C17.2467 20.5 21.5 16.2467 21.5 11C21.5 5.75329 17.2467 1.5 12 1.5ZM1 11C1 4.92487 5.92487 0 12 0C18.0751 0 23 4.92487 23 11C23 17.0751 18.0751 22 12 22C5.92487 22 1 17.0751 1 11Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 23.25C2 22.8358 2.33579 22.5 2.75 22.5H21.25C21.6642 22.5 22 22.8358 22 23.25C22 23.6642 21.6642 24 21.25 24H2.75C2.33579 24 2 23.6642 2 23.25Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_392_12238)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.8998 6.2998C12.1569 6.2998 12.3654 6.50822 12.3654 6.76532V10.3343H15.9344C16.1915 10.3343 16.3999 10.5427 16.3999 10.7998C16.3999 11.0569 16.1915 11.2653 15.9344 11.2653H12.3654V14.8343C12.3654 15.0914 12.1569 15.2998 11.8998 15.2998C11.6427 15.2998 11.4343 15.0914 11.4343 14.8343V11.2653H7.86542C7.60832 11.2653 7.3999 11.0569 7.3999 10.7998C7.3999 10.5427 7.60832 10.3343 7.86542 10.3343H11.4343V6.76532C11.4343 6.50822 11.6427 6.2998 11.8998 6.2998Z",
				fill: "var(--colors-grey-1)"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_392_12238",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 9,
				height: 9,
				fill: "white",
				transform: "translate(7.3999 6.2998)"
			})
		}) })
	]
});
export default SvgInserBelow;
